import axios from "axios";
import { IAgeGoup } from "../../../Models/AgeGroups/IAgeGroup";
import { IResult } from "../../../Models/Result/IResult";
import { formatUrl, handleError } from "../ApiHelpers";
import { IAgeGroupApi } from "./IAgeGroupApi";

export class AgeGroupApi implements IAgeGroupApi {

    private backendUrl: string;

    constructor(url: string) {
        this.backendUrl = url;
    }

    async getAgeGroups(filter: string): Promise<IResult<IAgeGoup[]>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/AgeGroups/GetAgeGroup?filter=${filter}`);
            const response = await axios.get(url);
            return response.data as IResult<IAgeGoup[]>;
        }
        catch (error) {
            return handleError(error, "getAgeGroups");
        }
    }

    async createAgeGroup(ageGroup: IAgeGoup): Promise<IResult<number>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/AgeGroups/CreateAgeGroup`);
            const response = await axios.post(url, ageGroup);
            return response.data as IResult<number>;
        }
        catch (error) {
            return handleError(error, "createAgeGroup");
        }
    }

    async updateAgeGroup(ageGroup: IAgeGoup): Promise<IResult<string>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/AgeGroups/UpdateAgeGroup/${ageGroup.id}`);
            const response = await axios.put(url, ageGroup);
            return response.data as IResult<string>;
        }
        catch (error) {
            return handleError(error, "updateAgeGroup");
        }
    }


    async deleteAgeGroup(id:number): Promise<IResult<string>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/AgeGroups/DeleteAgeGroup/${id}`);
            const response = await axios.delete(url);
            return response.data as IResult<string>;
        }
        catch (error) {
            return handleError(error, "deleteAgeGroup");
        } 
    }
}
